import { ReactNode, isValidElement } from 'react';
import {
  toast as originalToast,
  ToastOptions,
  TypeOptions,
} from 'react-toastify';
import CustomToast, { CustomToastProps } from './CustomToast';
import { t } from 'i18next';
import './toast.scss';

type ToastContent = ReactNode | CustomToastProps;

const autoCloseTime = 5000;

const isToastContentObject = (
  content: ToastContent,
): content is CustomToastProps => {
  return (
    content !== null && typeof content === 'object' && !isValidElement(content)
  );
};

const customToast =
  (type: TypeOptions) => (content: ToastContent, options?: ToastOptions) => {
    if (isToastContentObject(content)) {
      const confirmAction = content?.confirmAction;

      const isActionButtonPresent = !!confirmAction;
      return originalToast(
        (toastProps) => {
          const { closeToast } = toastProps;
          return <CustomToast {...content} closeToast={closeToast} />;
        },
        {
          type,
          closeButton: isActionButtonPresent ? false : !!options?.closeButton,
          autoClose:
            isActionButtonPresent || options?.closeButton === true
              ? false
              : autoCloseTime,
          hideProgressBar:
            options?.closeButton === true || isActionButtonPresent
              ? true
              : undefined,
          theme: 'colored',
          ...options,
        },
      );
    }

    return originalToast(t(content), {
      type,
      closeButton: false,
      autoClose: autoCloseTime,
      theme: 'colored',
      ...options,
    });
  };

const toast = {
  ...originalToast,
  success: customToast('success'),
  error: customToast('error'),
  info: customToast('info'),
  warning: customToast('warning'),
};

export default toast;
